import React from "react";

const Dashboard = ({ color = "#000000", size = "20" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
    >
      <rect
        x="11.1797"
        y="1.75"
        width="7.07143"
        height="4.5"
        rx="1.25"
        stroke={color}
        strokeWidth="1.5"
      />
      <rect
        x="1.75"
        y="13.75"
        width="7.07143"
        height="4.5"
        rx="1.25"
        stroke={color}
        strokeWidth="1.5"
      />
      <rect
        x="1.75"
        y="1.75"
        width="7.07143"
        height="9.64286"
        rx="1.25"
        stroke={color}
        strokeWidth="1.5"
      />
      <rect
        x="11.1797"
        y="8.60742"
        width="7.07143"
        height="9.64286"
        rx="1.25"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default Dashboard;
